import {Chip, Divider, Stack} from "@mui/material";
import {FC, ReactElement, ReactNode} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";
import {classNames} from "@helpers/classNames";


const baseSx: SxType = {
    chip: {padding: '0 10px'},
    chipWrapper: {
        '.lightTheme &.info':{
            backgroundColor: 'var(--account-accent-tint, #96dffe)',
            color:'var(--account-accent-on-tint, black)'
        }

    }
}

interface IProps {
    position?: 'left' | 'center' | 'right',
    label?: string | ReactNode,
    icon?: ReactElement,
    sx?: SxType,
    orientation?: 'horizontal' | 'vertical';
    chipColor?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
    onClick?: () => void,
    size?: 'small' | 'medium'
}

const DividerCustom: FC<IProps> = ({
                                       position,
                                       label,
                                       icon,
                                       sx,
                                       orientation,
                                       chipColor,
                                       onClick,
                                       size,
                                   }) => {

    if (!icon && !label) {
        return <Divider sx={sx}/>
    }
    return (
        <Divider
            variant={'fullWidth'}
            sx={sx}
            textAlign={position ?? 'left'}
            orientation={orientation}
        >
            <Chip
                icon={icon}
                className={classNames('chipCustom', chipColor)}
                color={chipColor}
                size={size}
                sx={baseSx.chipWrapper}
                label={<Stack
                    sx={baseSx.chip}
                    alignItems={'center'}
                    justifyContent={'center'}
                >
                    {label}
                </Stack>}
                onClick={onClick}
            />
        </Divider>
    );
};
export default DividerCustom;